var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('vue-tel-input-vuetify',{attrs:{"outlined":!_vm.inline,"placeholder":"","label":"Phone Number","defaultCountry":"US","mode":"international","required":_vm.required,"disabled":_vm.disabled,"rules":[
    (v) => _vm.required ? !!v || 'Phone Number is required' : true,
    _vm.isValidOrPossible,
    ..._vm.parsedRules
  ],"autoFormat":false,"wrapperClasses":_vm.classNames},on:{"input":_vm.onInput},model:{value:(_vm.number),callback:function ($$v) {_vm.number=$$v},expression:"number"}})
}
var staticRenderFns = []

export { render, staticRenderFns }